import axios, {AxiosInstance} from "axios";
import {UserActions} from "../user/UserActions";

export class HttpService {
    axios : AxiosInstance;
    baseUrl : string;

    constructor(baseUrl : string) {

        this.axios = axios.create({
            headers : {
                "Content-type" : "application/json"
            }
        })
        this.baseUrl = baseUrl;

    }
    get<R>(url : string) : Promise<R> {
        return  new Promise((resolve,reject)=> {
            this.axios.get(this.baseUrl + url, { withCredentials : true })
                .then(response => resolve(response.data))
                .catch(e => this.handleError(url, e, reject))
        })
    }
    post<R,E>(url: string, entity : E) : Promise<R> {
        return  new Promise((resolve,reject)=> {
            this.axios.post(this.baseUrl + url,entity, { withCredentials : true })
                .then(response => resolve(response.data))
                .catch(e => this.handleError(url, e, reject))
        })
    }

    put<R,E>(url:string, entity : E) : Promise<R> {
        return new Promise((resolve,reject) => {
            this.axios.put(this.baseUrl + url,entity, {withCredentials: true})
                .then(response => resolve(response.data))
                .catch(e => this.handleError(url, e, reject))
        })
    }

    delete(url: string) : Promise<{}> {
        return  new Promise((resolve,reject)=> {
            this.axios.delete(this.baseUrl + url,{ withCredentials : true })
                .then(r => resolve())
                .catch(e => this.handleError(url, e, reject))
        })
    }
    handleError(path: string, response : any, reject : (msg? : any)=>void) {
        if(path.indexOf("user/login") !== -1 || path.indexOf("user/info") !== -1) {
            console.log("Skipping error handling on resources ", path);
            reject({message : "Not logged in", status : response.status});
            return;
        }
        console.log("Error for path " + path + " with status " + response.status, response);
        let userActions = new UserActions();
        let status = response.request.status;
        if(status === 401) {
            userActions.getUserInfo(false);

        } else if(status === 403) {
            userActions.requestForbidden(JSON.parse(response.request.response));
        }
        if(status === 401 || status === 403){
            reject({ message : "Access denied", status : status });
        } else if(response.headers && response.headers["content-type"]  === "application/json") {
            reject({message : response.data.message, status : status})
        } else if(response.status >= 500 && response.status<600) {
            reject({ message : "Internal server error, if this persist please contact support. ", status : status });
        } else {
            reject({ message : "Error with status " + response.status, status : status });
        }
    }
}